import { render } from "./Colecciones.vue?vue&type=template&id=1ff962b8&scoped=true"
import script from "./Colecciones.vue?vue&type=script&lang=ts"
export * from "./Colecciones.vue?vue&type=script&lang=ts"

import "./Colecciones.vue?vue&type=style&index=0&id=1ff962b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ff962b8"

export default script